import utils from '../../helpers/utils';
import {useState} from 'react';
import Image from '../../components/common/VectorImage';
import useWhiteLabelClient from '../../customHooks/useWhiteLabelClient';

const AlertToggle = ({toggleData, value, option}: AlertToggleProps) => {
  const whiteLabelClient = useWhiteLabelClient();
  const toggleOnIcon = utils.safeGet(toggleData, 'onIcon', '');
  const toggleOffIcon = utils.safeGet(toggleData, 'offIcon', '');
  const toggleValue = utils.safeGet(toggleData, 'value', '');
  const toggleState = utils.safeGet(toggleData, 'state', true);
  const [isToggleOn, setIsToggleOn] = useState(toggleState);

  if (toggleOnIcon === '' && toggleOffIcon === '') {
    return null;
  }
  const iconName = isToggleOn ? toggleOffIcon : toggleOnIcon;
  const iconUrl = utils.getCdnImagesPath(`/dsp-northstar/${iconName}`, whiteLabelClient);

  const handleToggle = () => {
    setIsToggleOn(!isToggleOn);
    if (option) {
      utils.trackEvent(option);
    }
  };

  return (
    <div className="flex">
      {isToggleOn ? toggleValue : value}
      <div onClick={handleToggle}>
        <Image classes="ml-4 h-6 w-6 cursor-pointer" alt="toggle-icon" url={iconUrl} dataTestId={'alert-toggle-icon'} />
      </div>
    </div>
  );
};

export default AlertToggle;
